import React, { createContext, useState, useContext } from 'react';

const BreadcrumbContext = createContext();

export const useBreadcrumb = () => useContext(BreadcrumbContext);

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumb, setBreadcrumb] = useState('');
  const [disableOnErrorRes, setDisableOnErrorRes] = useState(false);

  return (
    <BreadcrumbContext.Provider value={{ breadcrumb, setBreadcrumb, disableOnErrorRes, setDisableOnErrorRes }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};
